import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { modalService } from '../../services/ModalService';
import { Modal } from '../Modal/Modal';
import PrimaryButton from '../PrimaryButton/PrimaryButton';
import SecondaryButton from '../SecondaryButton/SecondaryButton';
import CopyText from '../CopyText/CopyText';
import CONFIG from '../../config/config';
import { MessageCircle } from 'lucide-react';

const ErrorModalContainer: React.FC = () => {
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [contextId, setContextId] = useState<string | null>(null);

  useEffect(() => {
    modalService.setCallback((message, id) => {
      setErrorMessage(message);
      setContextId(id);
    });
  }, []);

  const handleClose = () => {
    setErrorMessage(null);
    setContextId(null);
  };

  const whatsappMessage = contextId
    ? t('global.error.whatsapp_message', { id: contextId })
    : t('global.error.whatsapp_message_fallback');
  const whatsappUrl = `${CONFIG.CONTACT_INFO.WHATSAPP}?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <>
      {errorMessage && (
        <Modal modalTitle={t('global.error')!} canClose onClose={handleClose}>
          <div className="py-2">
            <p className="text-slate-700 leading-snug">
              {t('global.error.friendly_message')}
            </p>
            {contextId && (
              <div className="mt-4 flex items-center gap-2">
                <span className="text-slate-500">
                  {t('global.error.reference_id')}:
                </span>
                <code className="rounded bg-slate-100 px-2 py-1 font-mono text-slate-700">
                  {contextId}
                </code>
                <CopyText text={contextId} />
              </div>
            )}
            <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
              <SecondaryButton text={t('global.close')!} fn={handleClose} />
              <PrimaryButton
                text={
                  <>
                    <MessageCircle className="h-4 w-4 mr-1.5 inline-block" />
                    {t('global.error.contact_whatsapp')}
                  </>
                }
                fn={() => window.open(whatsappUrl, '_blank', 'noopener,noreferrer')}
              />
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default ErrorModalContainer;
